var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 5.55503H9.16667V3.70352C9.16667 1.6613 7.52217 0.000488281 5.5 0.000488281C3.47783 0.000488281 1.83333 1.6613 1.83333 3.70352V5.55503H1.375C0.617222 5.55503 0 6.17775 0 6.94366V13.424C0 14.1899 0.617222 14.8126 1.375 14.8126H9.625C10.3828 14.8126 11 14.1899 11 13.424V6.94366C11 6.17775 10.3828 5.55503 9.625 5.55503ZM3.05556 3.70352C3.05556 2.34204 4.15189 1.23483 5.5 1.23483C6.84811 1.23483 7.94444 2.34204 7.94444 3.70352V5.55503H3.05556V3.70352ZM6.11111 10.3208V11.7267C6.11111 12.0674 5.83794 12.3439 5.5 12.3439C5.16206 12.3439 4.88889 12.0674 4.88889 11.7267V10.3208C4.52528 10.1067 4.27778 9.71291 4.27778 9.25806C4.27778 8.57732 4.82594 8.02371 5.5 8.02371C6.17406 8.02371 6.72222 8.57732 6.72222 9.25806C6.72222 9.71291 6.47472 10.1067 6.11111 10.3208Z",
    fill: "#9196A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.a666ac1e1df33b495ba8c8715ea7f278.svg";
export { ForwardRef as ReactComponent };